import { CVTemplateModern } from "./CVTemplateModern";
import { CVTemplateMinimal } from "./CVTemplateMinimal";
import { CVTemplateClassic } from "./CVTemplateClassic";
import { CVTemplateTech } from "./CVTemplateTech";
import type { CVData, CVTemplateId } from "../types";

const TEMPLATES: Record<CVTemplateId, React.ComponentType<{ data: CVData }>> = {
  modern: CVTemplateModern,
  minimal: CVTemplateMinimal,
  classic: CVTemplateClassic,
  tech: CVTemplateTech,
};

export function CVTemplateRenderer({
  templateId,
  data,
}: {
  templateId: CVTemplateId;
  data: CVData;
}) {
  const Template = TEMPLATES[templateId];
  if (!Template) return null;
  return <Template data={data} />;
}
